/* 
首页接口
*/
import request from '@/utils/request'
import base from './base';

// 删除原有的 host 定义
export const host = base.api_data;

// 定义API路径
const api_store_stats = '/home/get_store_stats/';//统计门店数量
const api_order_stats = '/home/get_order_stats/';//统计销售额（月，昨日）
const api_monthly_sales_stats = '/home/monthly_sales_stats/';//统计月度销售趋势
const api_monthly_delivery_stats = '/home/monthly_delivery_stats/';//统计月度配送趋势
const api_store_monthly_sales_rank = '/home/store_monthly_sales_rank/';//统计门店销售毛利排名
const api_monthly_item_stats = '/home/monthly_item_stats/';//统计月度商品销售毛利排名

// 优化请求函数，增加超时时间和错误处理
const apiRequest = async (url, params) => {
    try {
        console.log('发送请求:', url, params);
        const response = await request.get(`${host}${url}`, {
            params,
            // 增加超时时间到30秒，给后端更多处理时间
            timeout: 30000
        });
        return response;
    } catch (error) {
        console.error('请求失败:', url, error);
        // 如果是超时错误，提供更友好的错误信息
        if (error.code === 'ECONNABORTED' && error.message.includes('timeout')) {
            console.warn(`请求 ${url} 超时，请检查网络连接或稍后重试`);
        }
        throw error; // 抛出错误，让调用方处理
    }
};

// 导出API方法
export default {
    api_store_stats(params) {
        return apiRequest(api_store_stats, params);
    },
    api_order_stats(params) {
        return apiRequest(api_order_stats, params);
    },
    api_monthly_sales_stats(params) {
        return apiRequest(api_monthly_sales_stats, params);
    },
    api_monthly_delivery_stats(params) {
        return apiRequest(api_monthly_delivery_stats, params);
    },
    api_store_monthly_sales_rank(params) {
        return apiRequest(api_store_monthly_sales_rank, params);
    },
    api_monthly_item_stats(params) {
        return apiRequest(api_monthly_item_stats, params);
    }
}


